import React from 'react';
import { BlogPost } from '../data/blogs';
import {Link} from 'react-router-dom';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="p-6">
        <h3 className="text-xl font-fraunces-slab mb-2">{post.title}</h3>
        <p className="text-gray-600 mb-4">{post.content.substring(0, 100)}...</p>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-500">{new Date(post.date).toLocaleDateString()}</span>
          <div className="flex flex-wrap gap-2">
            {post.tags.slice(0, 3).map((tag, index) => (
              <span key={index} className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <Link 
          to={`/blogs/${post.slug}`}
          className="mt-4 inline-block text-purple-600 font-semibold hover:text-purple-800 transition-colors duration-300"
        >
          Read More
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;